// Post tags. One normalisation for every compose and edit surface — it used to
// be copied inline in three places.
//
// Normalised in the client only: create_post / update_post store tags as
// supplied (see CLAUDE.md, 036), so this must stay the single place it happens.

export const MAX_TAGS = 5;
export const MAX_TAG_LENGTH = 30;

// "Self Care!" → "self-care". Spaces become hyphens rather than vanishing.
export const normalizeTag = (raw) => String(raw ?? '')
  .trim()
  .toLowerCase()
  .replace(/^#+/, '')
  .replace(/\s+/g, '-')
  .replace(/[^a-z0-9-]/g, '')
  .replace(/-{2,}/g, '-')
  .replace(/^-|-$/g, '')
  .slice(0, MAX_TAG_LENGTH);

// Accepts an array or the comma-separated string drafts have always stored,
// so a draft saved before tag chips existed still restores.
export const parseTags = (value) => {
  const list = Array.isArray(value) ? value : String(value ?? '').split(',');
  const out = [];
  for (const raw of list) {
    const tag = normalizeTag(raw);
    if (tag && !out.includes(tag)) out.push(tag);
    if (out.length === MAX_TAGS) break;
  }
  return out;
};

export const joinTags = (tags) => tags.join(', ');
